
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiObjectData as ObcPoiObjectDataElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-object-data/poi-object-data.js';
 
 
 

 
 export const ObcPoiObjectData = createComponent({
   react: React,
   tagName: 'obc-poi-object-data',
   elementClass: ObcPoiObjectDataElement,
   events: {
     
   }
  });
 
 